import script from "./ProductionView.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductionView.vue?vue&type=script&setup=true&lang=js"

import "./ProductionView.vue?vue&type=style&index=0&id=140c2082&scoped=true&lang=css"

import exportComponent from "/builds/angeloferraro/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-140c2082"]])

export default __exports__